import transitions from "theme/config/transitions";

/**
 * @version 1.0
 * @param {object} SIZES define the button sizes from design
 * @param {object} OUTERSTYLES define the button wrapper styles from design
 * @param {object} INNERSTYLES define the button content styles from design
 * @param {object} THEMES define the button themes from design
 * @note Colors and Transitions is also to be modified to the design needs.
 */

export const SIZES = {
    xs: {
        padding: "18px",
        textStyle: "Myriad Pro/14-100", //Only for icons? No need for textStyle?
    },
    sm: {
        padding: "12px 16px",
        textStyle: "Myriad Pro/16-100-semibold-semiextended",
    },
    md: {
        padding: "14px 18px",
        textStyle: "Myriad Pro/16-100-semibold-semiextended",
    },
    lg: {
        padding: "16px 20px",
        textStyle: "Myriad Pro/18-100-semibold-semiextended",
    },
};

export const OUTERSTYLES = {
    borderRadius: "100px",
    cursor: "pointer",
    transition: `all ${transitions.primary}`,
    overflow: "hidden",
};

export const INNERSTYLES = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    textDecoration: "none",
    textWrap: "balance",
    transition: `all ${transitions.primary}`,
};
